var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';
import React from 'react';
import { colorPalette } from '../../colorPalette';
const CustomToggleButton = styled(MuiToggleButton)(() => ({
    border: '2px solid transparent',
    borderRadius: '8px',
    '&.Mui-selected': {
        border: '2px solid',
        borderRadius: '8px',
    },
    '&.Mui-selected.Mui-disabled': {
        backgroundColor: colorPalette.gray200,
    },
    '&.Mui-disabled': {
        borderColor: 'transparent',
        color: colorPalette.gray400,
    },
}));
export const ToggleButton = React.forwardRef((_a, ref) => {
    var { color, value, disabled: isDisabled, label, children } = _a, additionalProps = __rest(_a, ["color", "value", "disabled", "label", "children"]);
    return (React.createElement(CustomToggleButton, Object.assign({ ref: ref, color: color !== null && color !== void 0 ? color : 'secondary', value: value, disabled: isDisabled, "aria-label": label }, additionalProps), children));
});
